import React, { FC, ElementType, forwardRef } from 'react';
import { Box, BoxProps, IconButton, useTheme, AccordionSummaryOwnerState } from '@mui/material';

/**
 * AccordionSummary.slots.expandIconWrapper that replaces expand icon
 * Wrapper is used instead of expandIcon to gain access to ownerState
 */
export const FlowAccordionSummaryExpandWrapper: FC<
  BoxProps<ElementType> & {
    // @mui extend ownerState with expanded and disabled properties
    // https://github.com/mui/material-ui/blob/master/packages/mui-material/src/AccordionSummary/AccordionSummary.js#L132
    ownerState: AccordionSummaryOwnerState & { expanded: boolean; disabled: boolean; disableGutters: boolean };
  }
> = forwardRef(({ ownerState, children, ...rest }, ref) => {
  const { expanded, disabled } = ownerState;
  const theme = useTheme();

  return (
    <Box
      component="span"
      sx={{
        mr: '6px',
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
        '&.Mui-expanded': {
          transform: 'rotate(180deg)',
        },
      }}
      ref={ref}
      {...rest}
    >
      <IconButton
        aria-label="Toggle accordion"
        aria-expanded={expanded}
        className="MuiAccordion-IconButton"
        color={theme.palette.mode === 'dark' ? 'white' : 'secondary'}
        size="medium"
        disabled={disabled}
      >
        {children}
      </IconButton>
    </Box>
  );
});
